<template>
	<div class="battery-group row-center" style="justify-content: space-between;align-items: flex-start">

		<div class="left">
			<div class="tit">{{currentLoop.label}}</div>

			<div class="status row-center" style="justify-content: flex-start">
				充放电状态：
				<span style="margin-right: 8px;">待机</span>
				<img src="../../assets/img/battery-1.png" alt="">
			</div>

			<div class="ball row-center" style="justify-content: space-between">
				<div class="ball-item column-center">
					<div class="k">SOC（剩余电量%）</div>
					<div class="v">
						<!-- <Ball size="120" :v="battery"></Ball> -->
						<Ball size="120" v="80"></Ball>
					</div>
				</div>
				<div class="ball-item column-center">
					<div class="k">SOH（健康度%）</div>
					<div class="v">
						<Ball size="120" v="95"></Ball>
					</div>
				</div>
			</div>

		</div>


		<div class="right">
			<el-scrollbar style="height:100%">
				<ul>
					<li class="row-center" v-for="i in 16" :key="i">
						<div class="name">单体{{i}}</div>
						<div class="u">
							<span class="k">电压(V)：</span>
							<span class="v">{{ball[i]}}</span>
						</div>
						<div class="t">
							<span class="k">温度(℃)：</span>
							<span class="v">{{temp[i]}}</span>
						</div>
					</li>
				</ul>
			</el-scrollbar>
		</div>
	</div>
</template>

<script>
	import Ball from "./Ball";

	export default {
		name: "BatteryGroup",
		components:{
			Ball
		},
		props:{
			currentLoop:Object,
			battery:String
		},
		data(){
			return {
				ball:[2.9,3.2,3.3,2.8,3.5,3.2,2.9,3.1,3.0,2.9,2.9,3.2,3.3,2.8,3.5,3.2,2.9,],
				temp:[10,20,25,31,45,11,11,24,35,44,10,20,25,31,45,11,21,]
			}
		}
	}
</script>

<style scoped lang="less">
	.battery-group {
		background: #ffffff;
		padding: 24px 26px;
		.h(430)
	}

	.right {
		// width: 45%;
		padding-top: 30px;
		height: 300px;
		overflow-y: auto;
		ul {
			width: 100%;

			li {

				font-size: 18px;
				line-height: 1;
				border-bottom: 1px solid #CCCCCC;
				padding: 21px 0 11px 10px;

				div {

					span {
						&:last-child {
							color: rgba(13, 148, 255, 1);
						}
					}
				}

				.name {
					font-weight: bold;
					color: #333333;
					width: 220rem;
				}

				.u {
					font-weight: 400;
					color: #333333;
					width: 190rem;

				}

				.t {
					font-weight: 400;
					color: #333333;
					width: 180rem;
				}

			}
		}
	}

	.left {
		width:38%;

		.k {
			font-size: 18px;
			font-weight: bold;
			color: #333333;
			margin-bottom: 16px;
			line-height: 1;
		}

		.tit {
			font-size: 18px;
			font-weight: bold;
			color: #333333;
			margin-bottom: 21px;
			line-height: 1;
		}

		.status {
			font-size: 18px;
			font-weight: 400;
			color: #333333;
			margin-bottom: 63px;
		}
	}
</style>
